import _extends from "@babel/runtime/helpers/esm/extends";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import { LocaleHelper } from "../../../../lib/locale/LocaleHelper";
import { componentsLocales as en_GB } from "../locales/en";
import { componentsLocales as ru_RU } from "../locales/ru";
export * from "../types";
export var FileUploaderLocaleHelper = /*#__PURE__*/function (_LocaleHelper) {
  function FileUploaderLocaleHelper(isVersionGTE5_5) {
    if (isVersionGTE5_5 === void 0) {
      isVersionGTE5_5 = true;
    }
    var locales = {
      ru_RU: _extends({}, ru_RU, isVersionGTE5_5 && {
        chooseFile: 'Загрузить файл'
      }),
      en_GB: en_GB
    };
    return _LocaleHelper.call(this, locales) || this;
  }
  _inheritsLoose(FileUploaderLocaleHelper, _LocaleHelper);
  return FileUploaderLocaleHelper;
}(LocaleHelper);